import { Col, message, Row, Select, Space, Tag } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
    ButtonItem,
    Form,
    ModalItem,
    FormItem,
    InputItem,
    HeaderItem,
    BoxItem,
    SelectItem,
    DatePickerItem,
    TextAreaItem,
    TableItem,
    SelectInsumosItem,
    SwitchItem,
} from "../../../../Components/Items";
import moment from "moment";
import axios from "axios";
import SelectEmpleadosItem from "../../../../Components/SelectEmpleadosItem";
import HistorialTrabajo from "../../DashboardTaxidermia/HistorialTrabajo";

const { Option } = Select;

class VerAgrupacion extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
        archivos: [],
        imagenes: [],
        previewImage: '',
        previewVisible: false,
        previewTitle: '',
        previewImageArchivo: '',
        previewVisibleArchivo: false,
        previewTitleArchivo: '',
        todasInsumosVenta: [],
        objetoInsumosVenta: null,
        modalVerEtiqueta: false,
        piezasLote: [],
    };

    componentDidUpdate(prevProps) {
        if (this.props.visible !== prevProps.visible && this.props.visible) {
            this.consultarInformacionLote();
        }

    }

    consultarInformacionLote() {
        this.setState({ loading: true });
        axios.post("agrupaciones/datosParaVerAgrupacion", {
            agrupacionId: this.props.agrupacionId,
            empresaId: this.props.empresaId,
        }, {
            headers: this.props.headersToken,
        }).then((res) => {
            if (res.data.success === 2) {
                this.setState({
                    loading: false,
                    todasInsumosVenta: res.data.insumosVenta,
                    objetoInsumosVenta: res.data.insumosVenta.map((value) => {
                        return (
                            <Option value={value._id} key={value._id}>
                                {value.stringBuscar}
                            </Option>
                        );
                    }),
                    piezasLote: res?.data?.lote?.piezas || [],
                    piezasSeleccionadas: res?.data?.agrupacion?.piezasSeleccionadas && Array.isArray(res.data.agrupacion.piezasSeleccionadas) ?
                        res.data.agrupacion.piezasSeleccionadas.map(pieza => pieza._id)
                        : [],
                });
                this.formRef.current.setFieldsValue({
                    ...res.data.agrupacion,
                    fechaEntrega: res.data.agrupacion.fechaEntrega ? moment(res.data.agrupacion.fechaEntrega) : null,
                })
            } else {
                message.error("Error al consultar la información del lote");
            }
        })
    }

    cerrarVerAgrupacion() {
        this.formRef.current.resetFields();
        this.props.cerrarVerAgrupacion();
    }

    render() {
        return (
            <>
                <ModalItem
                    title={"Ver Agrupación"}
                    visible={this.props.visible}
                    spinning={this.state.loading}
                    onCancel={() => this.cerrarVerAgrupacion()}
                    paddingTop
                    width={1000}
                >
                    <Form
                        ref={this.formRef}
                        name="verAgrupacion"
                        layout
                        bottom={
                            <div style={{ display: "flex", justifyContent: "right" }}>
                                <Space style={{ maxWidth: '100%', display: "flex", justifyContent: "right" }} wrap>
                                    <ButtonItem
                                        type="primary"
                                        onClick={() => this.cerrarVerAgrupacion()}
                                        rojo
                                        style={{ display: "block", margin: "0 0 0 auto" }}
                                    >
                                        Cerrar
                                    </ButtonItem>
                                </Space>
                            </div>
                        }
                    >
                        <Row >
                            <Col span={12}>
                                {this.props.taxidermia && (
                                    <>
                                        <FormItem
                                            label="Empleados"
                                            name={"empleados"}
                                            fieldKey={"empleados"}
                                            margin
                                        >
                                            <SelectEmpleadosItem
                                                disabled
                                                empresaId={this.props.empresaId} // o donde sea que tengas almacenado el ID de la empresa
                                                headersToken={this.props.headersToken}
                                                sinBorde
                                                autoFocus
                                                dropdownMatchSelectWidth={600}
                                                width="100%"
                                                mode="multiple"
                                                placeholder="Empleados"
                                            />
                                        </FormItem>
                                    </>
                                )}
                                <FormItem
                                    label="Venta"
                                    name="formaVentaId"
                                    fieldKey="formaVentaId"
                                    margin
                                >
                                    <SelectItem
                                        disabled
                                        placeholder="Seleccionar Venta"
                                    >
                                        {this.state.objetoInsumosVenta}
                                    </SelectItem>
                                </FormItem>
                                <FormItem
                                    label="Fecha Entrega"
                                    name={"fechaEntrega"}
                                    fieldKey={"fechaEntrega"}
                                    margin
                                >
                                    <DatePickerItem
                                        disabled
                                        placeholder="Fecha Entrega"
                                        style={{ width: '100%' }}
                                        format="DD/MM/YYYY"
                                        disabledDate={(current) => current && current < moment().startOf('day')}
                                    />
                                </FormItem>
                            </Col>
                            <Col span={12}>
                                {this.props.taxidermia && (
                                    <>
                                        <FormItem
                                            label="Posición"
                                            name={"posicion"}
                                            fieldKey={"posicion"}
                                            margin
                                        >
                                            <InputItem disabled placeholder="Ej. Derecha" />
                                        </FormItem>
                                        <FormItem
                                            label="Talla"
                                            name={"tallaPiel"}
                                            fieldKey={"tallaPiel"}
                                            margin
                                        >
                                            <InputItem disabled placeholder="Talla" />
                                        </FormItem>
                                        <FormItem
                                            label="Forma"
                                            name={"formaId"}
                                            fieldKey={"formaId"}
                                            margin
                                        >
                                            <SelectInsumosItem
                                                disabled
                                                empresaId={this.props.empresaId} // o donde sea que tengas almacenado el ID de la empresa
                                                headersToken={this.props.headersToken}
                                                autoFocus
                                                dropdownMatchSelectWidth={600}
                                                placeholder="Forma"
                                                tiposInsumos="activos"
                                            />
                                        </FormItem>
                                        <FormItem
                                            label="H. extra"
                                            name="horarioExtra"
                                            fieldKey={"horarioExtra"}
                                            margin
                                        >
                                            <SwitchItem disabled />
                                        </FormItem>
                                    </>
                                )}
                            </Col>
                        </Row>
                        <HeaderItem>OBSERVACIONES</HeaderItem>
                        <BoxItem>
                            <Row>
                                <Col span={24}>
                                    <FormItem
                                        label="Observaciones"
                                        name={"observaciones"}
                                        fieldKey={"observaciones"}
                                        margin
                                        labelCol={{ span: 4 }}
                                        wrapperCol={{ span: 20 }}
                                    >
                                        <TextAreaItem
                                            disabled
                                            placeholder="Observaciones"
                                        />
                                    </FormItem>
                                </Col>
                            </Row>
                        </BoxItem>
                        <HeaderItem>PIEZAS</HeaderItem>
                        <BoxItem>
                            <Row>
                                <Col span={24}>
                                    <TableItem
                                        loading={this.state.loading}
                                        size="small"
                                        dataSource={this.state.piezasLote}
                                        // rowSelection={{
                                        //     selectedRowKeys: this.state.piezasSeleccionadas,
                                        //     getCheckboxProps: (record) => ({
                                        //         disabled: (!!record.agrupacionLoteId || record.estado === 0), // desactiva si tiene agrupación
                                        //         title: (record.agrupacionLoteId || record.estado === 0) ? "Ya está agrupado" : "",
                                        //     }),
                                        // }}
                                        columns={[
                                            {
                                                title: "Descripción",
                                                dataIndex: "descripcion",
                                                key: "descripcion",
                                                width: "40%",
                                                render: (text, record) => (
                                                    <span>
                                                        {record.descripcion}
                                                    </span>
                                                ),
                                            },
                                            {
                                                title: "Cantidad",
                                                dataIndex: "cantidad",
                                                key: "cantidad",
                                                width: "20%",
                                            },
                                            {
                                                title: "Estado",
                                                dataIndex: "agrupacionLoteId",
                                                key: "agrupacionLoteId",
                                                render: (agrupacionLoteId, record) => {
                                                    if (agrupacionLoteId || record.estado === 0) {
                                                        if (agrupacionLoteId?.toString() === this.props.agrupacionId?.toString()) {
                                                            return <Tag color="blue">Agrupación Actual</Tag>;
                                                        }
                                                        if (record.estado === 0) {
                                                            return <Tag color="red">Cancelada</Tag>;
                                                        }
                                                        return <Tag color="red">Agrupado</Tag>;
                                                    } else {
                                                        return <Tag color="green">Disponible</Tag>;
                                                    }
                                                },
                                                width: "30%",
                                            },
                                        ]}
                                        pagination={false}
                                    />
                                </Col>
                            </Row>
                        </BoxItem>
                        {this.props.taxidermia && (
                            <HistorialTrabajo
                                agrupacionId={this.props.agrupacionId}
                                recargar={this.props.visible}
                                ocultarVacio
                            />
                        )}
                    </Form>
                </ModalItem>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
        taxidermia: state.empresa.taxidermia,
    };
};

export default connect(mapStateToProps)(VerAgrupacion);
